function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 500,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5FF"
    },
    d: "M54.194,257.705c20.295,22.975,45.983,31.902,58.651,59.817 c8.684,19.135,4.61,41.789,11.026,61.798c8.794,27.426,37.686,45.85,66.487,45.949c28.801,0.099,56.255-16.219,73.345-39.401 c5.605-7.603,10.463-16.151,18.32-21.393c11.253-7.507,25.85-6.542,39.323-7.743c33.221-2.96,64.703-21.615,83.253-49.333 c0,0,48.122-56.781,14.056-138.012c-9.902-23.611-25.953-45.295-48.087-58.162c-22.134-12.868-60.65-13.174-83.44-1.507 c-24.23,12.404-40.339,39.591-66.897,45.563c-15.394,3.461-31.287-1.037-46.789-3.979c-21.745-4.128-43.911-6.692-65.868-3.904 c-25.843,3.282-51.91,16.24-63.965,45.374c-4.222,10.203-5.641,21.396-3.958,32.31 C41.159,234.869,44.973,247.266,54.194,257.705z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5FF"
    },
    d: "M253.902,89.933c-5.586-7.013-14.289-10.841-22.992-12.998 c-12.008-2.976-24.921-3.205-36.569,0.962c-11.648,4.167-21.865,13.05-26.16,24.652c-4.295,11.602-1.928,25.786,6.984,34.367 c4.994,4.808,12.007,7.394,18.902,7.375c4.089,0.436,8.266-0.024,12.109-1.504c8.551-3.294,14.835-10.771,23.035-14.862 c8.912-4.445,20.366-5.155,26.397-13.079C261.038,107.711,259.488,96.946,253.902,89.933z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5FF"
    },
    d: "M93.239,338.465c-0.931-1.907-1.797-3.837-2.363-5.879c-1.811-6.54-0.495-13.999-4.007-19.806 c-4.41-7.293-15.273-8.624-22.663-4.379c-7.39,4.246-11.616,12.552-13.418,20.882c-1.11,5.13-1.433,10.594,0.324,15.539 c2.044,5.751,6.693,10.22,11.762,13.618c5.636,3.778,12.218,6.551,19,6.321c3.02-0.102,6.064-0.903,8.75-2.306 c2.118-0.92,3.998-2.342,5.292-4.186c0.94-1.114,1.733-2.35,2.313-3.714C100.638,348.886,98.465,341.426,93.239,338.465z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M360.462,337.98h-211.74c-1.987,0-3.613-1.626-3.613-3.613v-135.86 c0-1.987,1.626-3.613,3.613-3.613h211.74c1.987,0,3.613,1.626,3.613,3.613v135.86 C364.075,336.354,362.449,337.98,360.462,337.98z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.529,
    y: 205.299,
    style: {
      fill: "#D5CBFB"
    },
    width: 208.126,
    height: 118.805
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5CBFB"
    },
    d: "M255.901,199.67c0,0.723-0.586,1.308-1.309,1.308c-0.723,0-1.308-0.586-1.308-1.308 c0-0.723,0.586-1.309,1.308-1.309C255.315,198.362,255.901,198.947,255.901,199.67z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5CBFB"
    },
    d: "M393.546,384.667l-26.896-42.806c-1.518-2.416-4.171-3.882-7.024-3.882H249.904h-6.07h-94.275 c-2.853,0-5.506,1.466-7.024,3.882l-26.896,42.806c-0.761,1.212-1.032,2.652-0.794,4.043h279.494 C394.577,387.32,394.307,385.879,393.546,384.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M114.845,388.711c0.049,0.287,0.112,0.572,0.205,0.852l0.424,1.272 c0.786,2.357,2.991,3.946,5.475,3.946h122.884h6.07h138.331c2.484,0,4.69-1.59,5.475-3.946l0.424-1.272 c0.093-0.28,0.156-0.566,0.205-0.852H114.845z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "159.679,359.104 160.989,356.223 154.508,356.223 153.121,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "171.096,350.902 171.739,349.399 172.328,348.02 166.057,348.02 164.747,350.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "162.328,356.223 161.019,359.104 167.591,359.104 168.822,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "161.543,355.003 162.853,352.121 156.483,352.121 155.095,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "293.498,348.02 294.223,350.902 299.796,350.902 298.994,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "193.503,356.223 192.623,359.104 199.249,359.104 200.091,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "185.754,356.223 184.717,359.104 191.348,359.104 192.228,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "177.969,356.223 176.815,359.104 183.421,359.104 184.458,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "170.148,356.223 168.917,359.104 175.501,359.104 176.655,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "300.26,348.02 301.062,350.902 306.269,350.902 305.426,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "215.913,352.121 215.188,355.003 220.428,355.003 221.075,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "272.764,348.02 273.254,350.902 279.301,350.902 278.732,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "214.962,350.902 215.687,348.02 210.191,348.02 209.388,350.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "208.122,350.902 208.925,348.02 203.759,348.02 202.916,350.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "221.349,350.902 221.996,348.02 216.944,348.02 216.22,350.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "306.697,348.02 307.539,350.902 314.055,350.902 313.173,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "188.705,348.02 187.668,350.902 193.855,350.902 194.31,349.415 194.736,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "186.372,350.902 187.409,348.02 181.253,348.02 180.1,350.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "173.655,348.02 172.423,350.902 178.786,350.902 179.386,349.402 179.939,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "287.189,348.02 287.835,350.902 292.965,350.902 292.24,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "279.975,348.02 280.544,350.902 286.585,350.902 285.939,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "201.645,350.902 202.488,348.02 196.011,348.02 195.13,350.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "209.265,346.801 210.013,344.118 204.899,344.118 204.114,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "202.844,346.801 203.628,344.118 197.205,344.118 196.384,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "265.643,348.02 265.979,350.902 272.017,350.902 271.527,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "229.45,346.801 229.98,344.118 224.123,344.118 223.521,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "222.27,346.801 222.873,344.118 217.926,344.118 217.252,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "215.994,346.801 216.668,344.118 211.279,344.118 210.531,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "336.857,348.02 338.088,350.902 344.438,350.902 343.128,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "172.85,346.801 173.997,344.118 167.83,344.118 166.611,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "180.428,346.801 181.502,344.118 175.323,344.118 174.176,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "195.109,346.801 195.929,344.118 190.109,344.118 189.144,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "344.468,348.02 345.778,350.902 352.114,350.902 350.726,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "187.848,346.801 188.813,344.118 182.816,344.118 181.742,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "314.448,348.02 315.33,350.902 321.517,350.902 320.48,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "228.832,356.223 228.263,359.104 234.532,359.104 235.023,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "201.362,356.223 200.52,359.104 205.836,359.104 206.639,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "221.405,356.223 220.758,359.104 227.02,359.104 227.589,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "207.906,356.223 207.103,359.104 212.898,359.104 213.623,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "214.881,356.223 214.156,359.104 219.507,359.104 220.154,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "237.658,348.02 237.167,350.902 243.206,350.902 243.541,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "236.629,346.801 237.086,344.118 231.223,344.118 230.693,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "229.642,352.121 229.073,355.003 235.231,355.003 235.722,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "329.245,348.02 330.399,350.902 336.762,350.902 335.53,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "242.729,355.003 243.064,352.121 236.959,352.121 236.468,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "321.775,348.02 322.813,350.902 329.085,350.902 327.931,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "163.407,350.902 164.717,348.02 158.458,348.02 157.07,350.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "302.082,359.104 301.279,356.223 295.562,356.223 296.286,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "209.048,352.121 208.246,355.003 213.93,355.003 214.655,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "312.8,346.801 311.98,344.118 305.557,344.118 306.34,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "327.442,346.801 326.369,344.118 320.371,344.118 321.337,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "320.041,346.801 319.075,344.118 313.256,344.118 314.076,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "285.664,346.801 285.062,344.118 279.205,344.118 279.734,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "278.492,346.801 277.962,344.118 272.099,344.118 272.556,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "335.009,346.801 333.862,344.118 327.683,344.118 328.757,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "298.654,346.801 297.906,344.118 292.516,344.118 293.191,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "291.933,346.801 291.258,344.118 286.312,344.118 286.914,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "295.029,359.104 294.304,356.223 289.031,356.223 289.677,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "340.268,359.104 339.036,356.223 332.53,356.223 333.684,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "324.469,359.104 323.431,356.223 316.956,356.223 317.837,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "356.064,359.104 354.675,356.223 348.196,356.223 349.506,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "348.167,359.104 346.857,356.223 340.363,356.223 341.594,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "332.369,359.104 331.215,356.223 324.728,356.223 325.764,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "288.427,359.104 287.781,356.223 281.596,356.223 282.165,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "342.574,346.801 341.355,344.118 335.188,344.118 336.335,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "353.468,350.902 359.315,350.902 357.686,348.02 352.08,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "308.666,359.104 307.823,356.223 302.545,356.223 303.348,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "350.139,346.801 348.846,344.118 342.694,344.118 343.913,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "316.562,359.104 315.681,356.223 309.094,356.223 309.936,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "356.998,346.801 355.481,344.118 350.2,344.118 351.493,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "305.07,346.801 304.287,344.118 299.172,344.118 299.92,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "265.705,359.104 265.37,356.223 259.048,356.223 259.165,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "171.902,352.121 171.259,353.625 170.67,355.003 177.144,355.003 178.297,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "272.717,355.003 272.226,352.121 266.12,352.121 266.456,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "169.343,355.003 170.576,352.121 164.192,352.121 163.507,353.628 162.883,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "223.247,348.02 222.6,350.902 228.64,350.902 229.209,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "230.453,348.02 229.883,350.902 235.93,350.902 236.421,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "194.757,352.121 193.876,355.003 200.447,355.003 201.289,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "179.611,352.121 178.457,355.003 184.896,355.003 185.933,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "202.56,352.121 201.718,355.003 206.979,355.003 207.782,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "258.884,352.121 259,355.003 265.228,355.003 264.892,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "187.23,352.121 186.193,355.003 192.601,355.003 193.482,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "264.274,346.801 263.961,344.118 258.561,344.118 258.669,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "280.922,359.104 280.353,356.223 274.162,356.223 274.652,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "251.845,344.118 251.736,346.801 257.448,346.801 257.34,344.118  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "251.687,348.02 251.571,350.902 257.613,350.902 257.497,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "264.751,350.902 264.415,348.02 258.718,348.02 258.834,350.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "271.319,346.801 270.862,344.118 265.189,344.118 265.502,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "251.522,352.121 251.405,355.003 257.779,355.003 257.663,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "251.357,356.223 251.24,359.104 257.944,359.104 257.828,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "250.516,346.801 250.624,344.118 245.223,344.118 244.911,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "237.866,346.801 243.683,346.801 243.995,344.118 238.324,344.118  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "280.112,355.003 279.542,352.121 273.462,352.121 273.954,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "222.326,352.121 221.679,355.003 227.83,355.003 228.399,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "144.544,360.323 143.119,362.844 149.966,362.844 151.18,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "307.467,355.003 306.625,352.121 301.402,352.121 302.206,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "303.688,360.323 304.391,362.844 309.759,362.844 309.022,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "293.997,355.003 293.272,352.121 288.11,352.121 288.756,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "250.02,359.104 250.136,356.223 243.815,356.223 243.48,359.104  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "326.203,360.323 327.11,362.844 333.866,362.844 332.858,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "346.303,355.003 344.993,352.121 338.609,352.121 339.841,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "334.172,360.323 335.18,362.844 341.867,362.844 340.789,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "236.26,356.223 235.769,359.104 242.252,359.104 242.587,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "146.861,356.223 145.233,359.104 151.767,359.104 153.155,356.223  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "267.074,360.323 267.368,362.844 274.053,362.844 273.624,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "168.396,360.323 167.318,362.844 174.004,362.844 175.013,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "249.971,360.323 243.338,360.323 243.045,362.844 249.869,362.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "338.514,355.003 337.284,352.121 330.888,352.121 332.041,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "152.534,360.323 151.319,362.844 157.979,362.844 159.125,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "280.785,352.121 281.355,355.003 287.506,355.003 286.86,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "310.292,360.323 311.029,362.844 317.706,362.844 316.934,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "282.406,360.323 282.903,362.844 289.267,362.844 288.702,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "315.308,355.003 314.427,352.121 307.896,352.121 308.737,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "322.993,355.003 321.955,352.121 315.703,352.121 316.584,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "274.861,360.323 275.29,362.844 281.66,362.844 281.163,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "318.21,360.323 318.982,362.844 325.814,362.844 324.907,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "151.498,348.02 149.869,350.902 155.717,350.902 157.105,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "350.06,360.323 351.206,362.844 357.865,362.844 356.65,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "153.703,344.118 152.187,346.801 157.692,346.801 158.984,344.118  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "330.727,355.003 329.574,352.121 323.251,352.121 324.289,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "233.895,362.844 234.324,360.323 176.327,360.323 175.317,362.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "289.952,360.323 290.517,362.844 295.97,362.844 295.335,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "244.434,350.902 250.351,350.902 250.467,348.02 244.769,348.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "362.323,356.223 356.029,356.223 359.219,362.844 366.066,362.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "355.443,355.003 361.634,355.003 360.004,352.121 354.055,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "354.089,355.003 352.701,352.121 346.332,352.121 347.642,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "241.817,362.844 242.11,360.323 235.561,360.323 235.132,362.844  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "251.192,360.323 251.09,362.844 266.141,362.844 265.846,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "342.116,360.323 343.193,362.844 349.867,362.844 348.721,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "300.94,355.003 300.136,352.121 294.53,352.121 295.255,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "296.593,360.323 297.228,362.844 303.125,362.844 302.422,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "149.179,352.121 147.551,355.003 153.742,355.003 155.13,352.121  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "165.271,346.801 166.491,344.118 160.338,344.118 159.046,346.801  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "160.464,360.323 159.318,362.844 165.991,362.844 167.069,360.323  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "250.185,355.003 250.302,352.121 244.292,352.121 243.957,355.003  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7B70EE"
    },
    points: "272.925,356.223 266.598,356.223 266.933,359.104 273.416,359.104  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M292.8,384.32h-76.415c-0.325,0-0.622-0.15-0.815-0.411c-0.193-0.261-0.248-0.589-0.153-0.9 l4.858-15.788c0.132-0.428,0.521-0.714,0.968-0.714h66.7c0.447,0,0.836,0.287,0.968,0.714l4.858,15.788 c0.096,0.311,0.04,0.639-0.153,0.9C293.422,384.17,293.125,384.32,292.8,384.32z M221.242,367.41 c-0.049,0-0.09,0.031-0.105,0.078l-4.857,15.788c-0.014,0.043,0.001,0.077,0.016,0.097c0.015,0.02,0.042,0.044,0.088,0.044 H292.8c0.046,0,0.073-0.024,0.088-0.044c0.015-0.02,0.03-0.054,0.017-0.097l-4.858-15.789c-0.014-0.045-0.057-0.077-0.105-0.077 H221.242z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1C1C84"
    },
    points: "291.701,223.505 208.694,236.597 288.505,276.529 371.169,264.235  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2525AD"
    },
    points: "208.694,236.597 208.694,238.496 288.565,280.236 371.169,266.053 371.169,264.235  288.505,276.529  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2525AD"
    },
    d: "M239.568,281.523l-1.272,8.439c0,0,34.085,27.367,82.146,13.911l0.736-6.594 C278.696,304.387,251.954,290.616,239.568,281.523z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C64B"
    },
    d: "M340.766,325.959c-4.448-3.528-7.599-8.732-9.1-14.207c-0.111-0.406-0.653-0.259-0.716,0.089 c-0.101-0.135-0.304-0.154-0.467-0.069c-0.078-0.282-0.537-0.411-0.713-0.07c-3.05,5.913-0.694,12.592,1.347,18.441 c0.16,0.46,0.669,0.212,0.508-0.249c-1.597-4.578-3.307-9.704-2.335-14.527c-0.542,6.098,1.49,12.343,5.212,17.182 c0.269,0.349,0.686-0.07,0.416-0.422c-3.379-4.393-5.125-9.968-4.945-15.505c0.104,2.181,0.442,4.356,1.14,6.413 c1.069,3.151,2.856,6.159,4.645,8.949c0.263,0.411,0.678-0.012,0.415-0.422c-1.719-2.682-3.202-5.563-4.275-8.574 c-0.46-1.29-0.762-2.642-0.955-4.013c1.028,4.435,3.17,8.605,6.249,11.99c0.324,0.356,0.753,0.04,0.425-0.321 c-3.374-3.709-5.402-8.458-6.239-13.358c1.238,4.589,3.522,8.929,6.539,12.657c0.305,0.377,0.623-0.032,0.315-0.413 c-2.945-3.639-4.892-7.894-6.108-12.371c1.638,4.618,3.764,9.073,7.519,12.357c0.368,0.322,0.77-0.051,0.403-0.372 c-2.579-2.256-4.279-5.303-5.665-8.359c1.504,2.672,3.312,5.169,5.41,7.426c0.332,0.357,0.612-0.211,0.284-0.564 c-1.846-1.985-3.262-4.184-4.634-6.509c1.413,1.893,3.055,3.617,4.915,5.092 C340.736,326.533,341.149,326.263,340.766,325.959z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C64B"
    },
    d: "M332.948,262.056c-1.734-2.072-4.075-3.434-6.473-4.597 c-4.769-2.312-10.066-3.317-15.235-4.295c-7.306-1.382-14.78-2.662-20.855-7.266c-0.236-0.179-0.464-0.089-0.6,0.093 c-0.012,0.011-0.02,0.025-0.03,0.037c-0.004,0.007-0.009,0.011-0.013,0.018c-0.146,0.18-0.186,0.439,0.031,0.646 c4.452,4.256,10.404,6.363,16.263,7.846c5.921,1.499,11.964,2.525,17.631,4.878c0.176,0.073,0.352,0.146,0.528,0.219 c0.034,0.014,0.221,0.1,0.223,0.099c0.29,0.141,0.577,0.286,0.866,0.429c1.061,0.526,2.094,1.071,3.065,1.754 c1.164,0.819,2.242,1.822,2.99,3.041c0.818,1.333,1.102,2.828,1.072,4.378c-0.031,1.613-0.33,3.217-0.592,4.805 c-0.271,1.645-0.515,3.294-0.768,4.941c-0.523,3.406-1.01,6.814-1.378,10.24c-0.809,7.542-1.03,15.235,0.326,22.73 c0.101,0.556,1.034,0.434,0.992-0.134c-0.527-7.113,0.053-14.245,1.051-21.292c0.497-3.507,1.099-7,1.712-10.489 c0.575-3.275,1.335-6.576,1.604-9.894C335.602,267.234,334.905,264.395,332.948,262.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8A32B"
    },
    d: "M329.623,312.588c0.086-0.042,0.173-0.08,0.261-0.117c0.053-0.021,0.051-0.02-0.008,0.002 c0.026-0.009,0.051-0.019,0.077-0.027c0.039-0.013,0.078-0.026,0.117-0.038c0.189-0.058,0.382-0.1,0.578-0.128 c0.047-0.007,0.095-0.015,0.142-0.018c-0.132,0.007,0.022,0,0.048-0.002c0.095-0.005,0.191-0.007,0.286-0.005 c0.095,0.002,0.19,0.007,0.285,0.016c0.047,0.005,0.095,0.01,0.142,0.016c0.027,0.004,0.054,0.007,0.081,0.012 c-0.066-0.012-0.07-0.013-0.013-0.002c0.139,0.026,0.261,0.033,0.391-0.036c0.107-0.057,0.211-0.173,0.243-0.293 c0.064-0.237-0.051-0.582-0.329-0.634c-0.949-0.177-1.907-0.065-2.778,0.362c-0.238,0.117-0.343,0.454-0.207,0.684 C329.082,312.623,329.369,312.713,329.623,312.588L329.623,312.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8A32B"
    },
    d: "M329.522,311.602c0.086-0.042,0.173-0.08,0.261-0.117c0.053-0.021,0.051-0.02-0.008,0.002 c0.026-0.009,0.051-0.018,0.077-0.027c0.039-0.013,0.078-0.026,0.117-0.038c0.189-0.058,0.382-0.101,0.578-0.128 c0.047-0.007,0.095-0.015,0.142-0.018c-0.132,0.007,0.022,0,0.048-0.002c0.095-0.005,0.191-0.007,0.286-0.005 c0.095,0.002,0.191,0.007,0.285,0.017c0.048,0.005,0.095,0.01,0.142,0.016c0.027,0.004,0.054,0.008,0.081,0.012 c-0.066-0.012-0.071-0.013-0.013-0.002c0.139,0.026,0.261,0.033,0.391-0.036c0.107-0.057,0.212-0.174,0.243-0.293 c0.064-0.237-0.051-0.583-0.329-0.634c-0.95-0.177-1.907-0.065-2.778,0.362c-0.237,0.117-0.343,0.455-0.207,0.684 C328.981,311.637,329.267,311.727,329.522,311.602L329.522,311.602z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0C0C5B"
    },
    points: "323.674,277.421 324.086,274.137 288.565,280.236 243.848,256.867 242.89,262.389  287.672,284.934  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C1C84"
    },
    d: "M287.672,284.934l-44.783-22.545l-3.321,19.134c12.386,9.093,39.128,22.864,81.61,15.757 l2.495-19.859L287.672,284.934z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF6DC"
    },
    d: "M233.385,310.894c1.982,5.339-2.277,11.844-9.512,14.53 c-7.235,2.686-11.365-0.701-14.259-5.606c-4.233-7.174-0.153-11.043,7.082-13.729 C223.932,303.404,231.403,305.555,233.385,310.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M161.136,252.093c0,0,17.955,18.49,32.668,51.677c0,0,6.978,18.016,11.556,22.52 c0,0-3.705-4.175,1.953-10.841c4.156-4.896,10.217-7.896,16.634-8.123c3.585-0.127,7.331,0.623,9.463,3.637 c0,0-23.946-28.208-39.591-52.547c-6.251-9.724-9.21-17.758-10.509-23.9c0,0-1.179-1.387-3.528-2.547 c-8.638-4.266-18.813,1.476-20.32,10.991c-0.141,0.888-0.229,1.834-0.252,2.84C159.21,245.8,159.086,250.017,161.136,252.093z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4E7BD"
    },
    d: "M205.36,326.291c0,0,7.859,9.482,25.657-1.896c0,0,11.016-7.349,5.517-20.15 c0,0-11.424-8.516-20.432-19.311c-9.008-10.795-20.15-25.492-29.395-44.931l-2.357-1.426c0,0,1.699,9.218,12.702,24.751 c11.003,15.534,31.3,41.54,31.3,41.54l3.104,3.74c1.782,2.147,2.394,5.096,1.41,7.707c-1.402,3.718-5.515,8.122-17,8.79 l-7.172-11.135C208.694,313.971,201.73,319.738,205.36,326.291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M222.744,292.153c0,0-20.627-21.509-35.087-55.556c0,0-2.608-4.145-4.267-6.058 C183.39,230.538,195.96,269.393,222.744,292.153z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C64B"
    },
    d: "M184.807,285.911c4.34-7.827,13.717-13.004,22.644-12.556c3.177,0.159,3.168-3.792,0-3.951 c-10.587-0.531-21.083,4.753-26.217,14.015C181.234,283.418,183.264,288.694,184.807,285.911L184.807,285.911z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2525AD"
    },
    d: "M152.851,300.299h-40.483c-5.367,0-9.758-4.391-9.758-9.758v-21.083 c0-5.367,4.391-9.758,9.758-9.758h40.483c5.367,0,9.758,4.391,9.758,9.758v21.083 C162.609,295.908,158.218,300.299,152.851,300.299z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D5CBFB"
    },
    points: "126.17,280 126.17,272.565 132.61,276.282 139.049,280 132.61,283.718 126.17,287.435  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M120.888,210.758c0-12.396-10.049-22.444-22.444-22.444C86.049,188.314,76,198.362,76,210.758 c0,8.984,5.28,16.731,12.905,20.317v7.158h19.079v-7.158C115.608,227.489,120.888,219.742,120.888,210.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C64B"
    },
    d: "M108.598,241.932H88.29c-1.018,0-1.85-0.832-1.85-1.85l0,0c0-1.018,0.832-1.85,1.85-1.85h20.309 c1.017,0,1.85,0.832,1.85,1.85l0,0C110.448,241.1,109.616,241.932,108.598,241.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C64B"
    },
    d: "M98.444,252.43L98.444,252.43c-4.098,0-7.42-3.322-7.42-7.42v-1.227h14.841v1.227 C105.864,249.108,102.542,252.43,98.444,252.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8A32B"
    },
    d: "M108.598,245.632H88.29c-1.018,0-1.85-0.833-1.85-1.85l0,0c0-1.017,0.832-1.85,1.85-1.85h20.309 c1.017,0,1.85,0.832,1.85,1.85l0,0C110.448,244.8,109.616,245.632,108.598,245.632z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C64B"
    },
    d: "M100.485,238.233h-1.052v-31.18c0-0.545-0.444-0.989-0.989-0.989c-0.546,0-0.99,0.444-0.99,0.989 v31.18h-1.052v-31.18c0-1.126,0.916-2.041,2.042-2.041c1.126,0,2.041,0.915,2.041,2.041V238.233z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M63.167,203.106l-0.616,3.212l9.381,1.798c0.126-1.096,0.318-2.171,0.572-3.223L63.167,203.106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M70.598,188.314l-1.978,2.609l7.482,5.664c0.599-0.915,1.253-1.792,1.957-2.624L70.598,188.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M83.713,178.323l-2.922,1.471l4.206,8.338c0.939-0.549,1.912-1.045,2.919-1.478L83.713,178.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M134.337,206.318l-0.616-3.212l-9.338,1.787c0.254,1.051,0.447,2.127,0.572,3.223 L134.337,206.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M128.267,190.923l-1.978-2.609l-7.461,5.649c0.704,0.833,1.357,1.709,1.957,2.624 L128.267,190.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M116.097,179.794l-2.922-1.471l-4.204,8.332c1.007,0.433,1.98,0.929,2.919,1.478L116.097,179.794 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M100.116,184.552l-0.081-9.492l-3.273,0.03l0.082,9.456c0.53-0.031,1.062-0.052,1.599-0.052 C99.006,184.495,99.563,184.518,100.116,184.552z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.124,
    y: 382.176,
    style: {
      fill: "#F0C64B"
    },
    width: 94.85,
    height: 18.701
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 340.462,
    y: 382.176,
    style: {
      fill: "#D8A32B"
    },
    width: 3.82,
    height: 18.701
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.196,
    y: 382.176,
    style: {
      fill: "#D8A32B"
    },
    width: 3.821,
    height: 18.701
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 415.081,
    y: 382.176,
    style: {
      fill: "#D8A32B"
    },
    width: 3.821,
    height: 18.701
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.814,
    y: 382.176,
    style: {
      fill: "#D8A32B"
    },
    width: 3.821,
    height: 18.701
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M439.1,371.755v-2.877c0-4.089-3.327-7.415-7.415-7.415h-84.536v17.708h84.536 C435.773,379.171,439.1,375.844,439.1,371.755z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2525AD"
    },
    d: "M431.684,358.347h-85.089v1.558v1.558h85.089c4.089,0,7.415,3.327,7.415,7.415v2.877 c0,4.089-3.327,7.415-7.415,7.415h-85.089v1.558v1.558h85.089c5.807,0,10.531-4.724,10.531-10.531v-2.877 C442.215,363.071,437.491,358.347,431.684,358.347z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 347.148,
    y: 365.427,
    style: {
      fill: "#F5F5FF"
    },
    width: 86.192,
    height: 1.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.148,
    y: 369.695,
    style: {
      fill: "#F5F5FF"
    },
    width: 86.192,
    height: 1.417
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.148,
    y: 373.963,
    style: {
      fill: "#F5F5FF"
    },
    width: 86.192,
    height: 1.417
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M339.902,348.975v-2.591c0-3.682,2.995-6.677,6.677-6.677h76.12v15.945h-76.12 C342.898,355.652,339.902,352.657,339.902,348.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C64B"
    },
    d: "M346.579,336.901h76.618v1.403v1.403h-76.618c-3.682,0-6.677,2.995-6.677,6.677v2.591 c0,3.682,2.995,6.677,6.677,6.677h76.618v1.403v1.403h-76.618c-5.229,0-9.483-4.254-9.483-9.483v-2.591 C337.096,341.155,341.35,336.901,346.579,336.901z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 345.088,
    y: 343.276,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 767.7867 687.8283)",
    style: {
      fill: "#F5F5FF"
    },
    width: 77.611,
    height: 1.276
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.088,
    y: 347.12,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 767.7867 695.515)",
    style: {
      fill: "#F5F5FF"
    },
    width: 77.611,
    height: 1.276
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.088,
    y: 350.963,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 767.7867 703.2015)",
    style: {
      fill: "#F5F5FF"
    },
    width: 77.611,
    height: 1.276
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C64B"
    },
    d: "M186.959,138.065L186.959,138.065c3.583,0,6.487,2.816,6.487,6.289v0.957 c1.305,3.671,2.099,8.449,2.099,13.688s-0.795,10.016-2.099,13.688v0.957c0,3.473-2.904,6.289-6.487,6.289l0,0 c-4.742,0-8.586-9.372-8.586-20.934C178.372,147.437,182.217,138.065,186.959,138.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8A32B"
    },
    d: "M181.29,159.265c0,7.072,0.548,12.806,1.223,12.806c0.676,0,1.223-5.733,1.223-12.806 c0-7.072-0.548-12.806-1.223-12.806C181.838,146.46,181.29,152.193,181.29,159.265z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M202.529,149.513v0.839v17.827v0.839c-0.442,4.826-4.881,9.299-10.831,10.915v-11.754v-17.827 v-11.754C197.648,140.214,202.087,144.687,202.529,149.513z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2525AD"
    },
    d: "M191.698,182.173L191.698,182.173c0.969,0,1.761-0.768,1.761-1.707v-42.401 c0-0.939-0.793-1.708-1.761-1.708l0,0c-0.969,0-1.761,0.768-1.761,1.708v42.401 C189.936,181.405,190.729,182.173,191.698,182.173z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0C64B"
    },
    d: "M153.26,138.065L153.26,138.065c-3.583,0-6.487,2.816-6.487,6.289v0.957 c-1.305,3.671-2.099,8.449-2.099,13.688s0.795,10.016,2.099,13.688v0.957c0,3.473,2.904,6.289,6.487,6.289l0,0 c4.742,0,8.586-9.372,8.586-20.934C161.846,147.437,158.002,138.065,153.26,138.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8A32B"
    },
    d: "M158.928,159.265c0,7.072-0.548,12.806-1.223,12.806c-0.675,0-1.223-5.733-1.223-12.806 c0-7.072,0.548-12.806,1.223-12.806C158.38,146.46,158.928,152.193,158.928,159.265z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M137.689,149.513v0.839v17.827v0.839c0.442,4.826,4.881,9.299,10.831,10.915v-11.754v-17.827 v-11.754C142.57,140.214,138.131,144.687,137.689,149.513z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2525AD"
    },
    d: "M148.521,182.173L148.521,182.173c-0.969,0-1.761-0.768-1.761-1.707v-42.401 c0-0.939,0.792-1.708,1.761-1.708l0,0c0.969,0,1.761,0.768,1.761,1.708v42.401 C150.282,181.405,149.489,182.173,148.521,182.173z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M191.864,112.261c-3.519-2.905-8.134-4.744-12.511-5.818c-4.494-1.103-9.188-1.385-13.783-0.852 c-1.387,0.161-2.768,0.378-4.134,0.666c-0.935,0.197-1.962,0.351-2.829,0.762c-0.906,0.43-1.794,0.904-2.69,1.356 c-2.426,1.223-4.853,2.446-7.279,3.669c-0.966,0.487-0.852,1.9,0,2.416c2.243,1.36,4.812,1.534,7.352,1.129 c1.786-0.285,3.417-0.948,5.112-1.535c3.045-1.055,6.335-1.571,9.551-1.586c2.867-0.013,5.775,0.416,8.424,1.549 c3.919,1.688,8.607,2.811,12.504,0.443C192.289,114.028,192.58,112.852,191.864,112.261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2525AD"
    },
    d: "M170.715,104.035l0.006-0.031c-0.205,0-0.407,0.012-0.612,0.015 c-0.204-0.003-0.406-0.015-0.612-0.015l0.006,0.031c-20.204,0.644-36.388,17.214-36.388,37.574v22.818 c0,2.534,2.054,4.589,4.589,4.589v-22.496l-0.099-0.585c-1.546-9.123,0.431-18.618,5.997-26.009 c2.6-3.452,6.122-6.703,10.89-9.052c0.057-0.028,0.113-0.055,0.17-0.083c9.715-4.736,21.18-4.736,30.895,0 c0.057,0.028,0.113,0.055,0.17,0.083c4.797,2.363,8.332,5.639,10.936,9.113c5.534,7.385,7.493,16.856,5.95,25.954l-0.098,0.58 v22.496c2.534,0,4.589-2.054,4.589-4.589V141.61C207.103,121.249,190.919,104.679,170.715,104.035z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 388.473,
    y: 185.82,
    style: {
      fill: "#D5CBFB"
    },
    width: 59.667,
    height: 86.288
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 394.913,
    y: 198.476,
    style: {
      fill: "#7B70EE"
    },
    width: 46.786,
    height: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.913,
    y: 207.243,
    style: {
      fill: "#7B70EE"
    },
    width: 46.786,
    height: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.913,
    y: 216.011,
    style: {
      fill: "#7B70EE"
    },
    width: 46.786,
    height: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.913,
    y: 224.778,
    style: {
      fill: "#7B70EE"
    },
    width: 46.786,
    height: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.913,
    y: 233.545,
    style: {
      fill: "#7B70EE"
    },
    width: 46.786,
    height: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.913,
    y: 242.313,
    style: {
      fill: "#7B70EE"
    },
    width: 46.786,
    height: 1.91
  })), /*#__PURE__*/React.createElement("rect", {
    x: 394.914,
    y: 263.61,
    style: {
      fill: "#FFFFFF"
    },
    width: 46.786,
    height: 0.526
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7B70EE"
    },
    d: "M401.306,255.324c2.39,0.402,4.817,0.522,7.233,0.312c2.232-0.194,4.602-0.57,6.684-1.428 c1.482-0.611,3.097-2.285,2.057-3.977c-0.916-1.491-3.215-1.643-4.738-1.281c-1.776,0.423-3.356,1.586-4.436,3.038 c-1.081,1.453-1.833,3.548-0.554,5.12c1.182,1.452,3.346,1.743,5.089,1.501c0.979-0.136,1.933-0.46,2.79-0.956 c0.4-0.232,0.771-0.506,1.126-0.801c0.464-0.384,0.951-0.894,1.578-0.981c0.753-0.105,0.926,0.465,1.405,0.875 c0.333,0.285,0.761,0.381,1.19,0.338c0.529-0.054,1.01-0.282,1.5-0.471c0.617-0.239,1.227-0.328,1.888-0.313 c2.846,0.068,5.715,0.446,8.552,0.677c0.506,0.041,0.504-0.432,0-0.473c-2.112-0.172-4.225-0.659-6.337-0.83 c-0.964-0.078-1.955-0.226-2.923-0.147c-0.91,0.075-1.641,0.547-2.512,0.734c-0.979,0.209-1.114-0.775-1.898-1.077 c-0.696-0.267-1.462-0.042-2.057,0.356c-0.726,0.485-1.317,1.117-2.093,1.536c-0.87,0.469-1.852,0.751-2.839,0.811 c-1.6,0.097-3.982-0.391-4.319-2.284c-0.308-1.727,1.125-3.51,2.373-4.529c1.282-1.047,3.012-1.74,4.683-1.434 c0.795,0.146,1.833,0.52,2.028,1.412c0.227,1.041-0.693,1.881-1.528,2.29c-0.975,0.478-2.102,0.722-3.156,0.957 c-1.17,0.261-2.355,0.445-3.55,0.549c-2.343,0.203-4.704,0.317-7.023-0.074C401.019,254.69,400.805,255.24,401.306,255.324 L401.306,255.324z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5CBFB"
    },
    d: "M468.084,238.197l-10.489-5.691l3.083-5.683c0.667-1.23,2.205-1.686,3.435-1.019l6.035,3.275 c1.23,0.667,1.686,2.205,1.019,3.435L468.084,238.197z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.994,
    y: 232.85,
    transform: "matrix(0.8789 0.4769 -0.4769 0.8789 180.3116 -181.1359)",
    style: {
      fill: "#2525AD"
    },
    width: 11.934,
    height: 63.528
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.83,
    y: 232.85,
    transform: "matrix(0.8789 0.4769 -0.4769 0.8789 180.3062 -181.1326)",
    style: {
      fill: "#1C1C84"
    },
    width: 4.262,
    height: 63.528
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.404,
    y: 234.012,
    transform: "matrix(0.8789 0.4769 -0.4769 0.8789 168.3117 -192.2159)",
    style: {
      fill: "#F0C64B"
    },
    width: 14.775,
    height: 2.856
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D5CBFB"
    },
    points: "437.056,295.378 426.567,289.687 425.503,299.203 429.658,301.458  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2525AD"
    },
    points: "429.658,301.458 425.503,299.203 424.805,305.445  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#7B70EE",
      strokeWidth: 2.1457,
      strokeMiterlimit: 10
    },
    x1: 92.965,
    y1: 141.242,
    x2: 103.698,
    y2: 151.975
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#7B70EE",
      strokeWidth: 2.1457,
      strokeMiterlimit: 10
    },
    x1: 103.914,
    y1: 141.242,
    x2: 93.181,
    y2: 151.975
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#7B70EE",
      strokeWidth: 2.1457,
      strokeMiterlimit: 10
    },
    x1: 454.037,
    y1: 302.228,
    x2: 464.77,
    y2: 312.961
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#7B70EE",
      strokeWidth: 2.1457,
      strokeMiterlimit: 10
    },
    x1: 464.985,
    y1: 302.228,
    x2: 454.252,
    y2: 312.961
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2525AD",
      strokeWidth: 1.9001,
      strokeMiterlimit: 10
    },
    x1: 62.68,
    y1: 264.615,
    x2: 72.185,
    y2: 274.119
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2525AD",
      strokeWidth: 1.9001,
      strokeMiterlimit: 10
    },
    x1: 72.375,
    y1: 264.615,
    x2: 62.871,
    y2: 274.119
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#7B70EE",
      strokeWidth: 2.1457,
      strokeMiterlimit: 10
    },
    d: "M57.644,185.82 c0,4.29-3.478,7.768-7.768,7.768c-4.29,0-7.768-3.478-7.768-7.768c0-4.29,3.478-7.768,7.768-7.768 C54.166,178.051,57.644,181.529,57.644,185.82z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#7B70EE",
      strokeWidth: 2.1457,
      strokeMiterlimit: 10
    },
    cx: 361.634,
    cy: 172.071,
    r: 7.768
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2525AD",
      strokeWidth: 1.9001,
      strokeMiterlimit: 10
    },
    d: "M397.072,161.239 c0,1.09-0.884,1.974-1.974,1.974c-1.09,0-1.974-0.884-1.974-1.974s0.884-1.974,1.974-1.974 C396.188,159.265,397.072,160.149,397.072,161.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2525AD",
      strokeWidth: 1.9001,
      strokeMiterlimit: 10
    },
    d: "M206.724,95.422 c0,1.09-0.884,1.974-1.974,1.974s-1.974-0.884-1.974-1.974s0.884-1.974,1.974-1.974S206.724,94.332,206.724,95.422z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2525AD"
    },
    d: "M80.768,345.921v4.668c-6.272,0.353-11.27,5.553-11.27,11.912v3.972 c0,6.516,5.246,11.821,11.734,11.935c2.356,12.782,13.55,22.469,27.014,22.469h0c15.176,0,27.478-12.302,27.478-27.478v-27.478 H80.768z M73.359,366.472v-3.972c0-4.23,3.267-7.706,7.409-8.051v18.949c0,0.378,0.013,0.752,0.028,1.126 C76.641,374.193,73.359,370.712,73.359,366.472z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5CBFB"
    },
    d: "M122.036,314.64c-3.496-1.803-8.089-0.953-10.899,1.8c-0.504-4.01-4.315-7.04-8.311-7.638 c-3.997-0.598-8.052,0.803-11.559,2.812c-3.439,1.97-6.65,4.703-8.091,8.395c-1.441,3.692-0.634,8.451,2.631,10.697 c1.326,0.912,3.016,1.169,4.603,0.903c0.209,1.256,0.706,2.454,1.523,3.447c2.723,3.311,8.345,3.638,11.434,0.666 c2.344,2.074,5.942,2.598,8.78,1.278c0.617-0.287,1.188-0.662,1.707-1.099c-0.209,2.751-1.254,5.444-3.014,7.572 c3.409-1.186,6.324-3.728,7.962-6.945c1.074-2.109,1.579-4.492,1.512-6.856c2.654-0.511,5.089-2.453,5.953-5.051 C127.51,320.887,125.533,316.442,122.036,314.64z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2525AD"
    },
    d: "M245.356,149.694l-0.005-0.001c-0.142-0.012-0.29-0.019-0.44-0.019 c-2.924,0-5.303,2.379-5.303,5.303c0,2.924,2.379,5.303,5.303,5.303c0.15,0,0.296-0.006,0.433-0.018 c2.733-0.225,4.87-2.546,4.87-5.285C250.214,152.239,248.08,149.918,245.356,149.694z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2525AD"
    },
    d: "M263.94,154.978c0-0.916-0.357-1.777-1.006-2.426c-0.648-0.648-1.51-1.005-2.426-1.005h-1.964 l-0.202-0.664c-0.263-0.866-0.613-1.709-1.038-2.506l-0.327-0.612l1.39-1.39c1.338-1.338,1.338-3.515,0-4.853 c-0.648-0.648-1.51-1.005-2.427-1.005c-0.917,0-1.778,0.357-2.426,1.004l-1.39,1.39l-0.612-0.327 c-0.797-0.426-1.64-0.775-2.506-1.038l-0.663-0.202v-1.964c0-1.625-1.156-3.04-2.748-3.363c-0.224-0.045-0.455-0.068-0.683-0.068 c-0.916,0-1.778,0.357-2.426,1.005c-0.648,0.649-1.005,1.51-1.005,2.426v1.964l-0.663,0.202 c-0.866,0.263-1.709,0.613-2.506,1.038l-0.612,0.327l-1.39-1.39c-1.337-1.337-3.515-1.337-4.853,0 c-0.647,0.648-1.004,1.51-1.004,2.427c0,0.917,0.357,1.778,1.005,2.426l1.39,1.39l-0.327,0.612 c-0.426,0.797-0.775,1.64-1.039,2.506l-0.202,0.664h-1.964c-1.892,0-3.431,1.539-3.431,3.431c0,0.916,0.357,1.778,1.005,2.426 c0.648,0.648,1.51,1.005,2.426,1.005h1.964l0.202,0.663c0.264,0.866,0.613,1.709,1.039,2.506l0.327,0.612l-1.39,1.39 c-1.338,1.338-1.338,3.515,0,4.853c0.648,0.647,1.509,1.004,2.427,1.004c0.917,0,1.778-0.357,2.426-1.005l1.39-1.39l0.612,0.327 c0.797,0.426,1.64,0.775,2.506,1.039l0.663,0.202v1.964c0,1.892,1.539,3.431,3.431,3.431c0.222,0,0.447-0.022,0.667-0.065 l0.105-0.022c0.626-0.144,1.196-0.46,1.654-0.918c0.648-0.649,1.005-1.51,1.005-2.426v-1.964l0.663-0.202 c0.866-0.263,1.709-0.613,2.506-1.039l0.612-0.327l1.39,1.391c0.646,0.646,1.508,1.002,2.426,1.002 c0.918,0,1.78-0.356,2.427-1.003c0.647-0.648,1.004-1.51,1.004-2.427c0-0.916-0.357-1.778-1.005-2.426l-1.39-1.389l0.327-0.612 c0.426-0.797,0.775-1.641,1.039-2.506l0.202-0.663h1.964C262.4,158.409,263.94,156.87,263.94,154.978z M252.01,161.544 c-1.648,1.781-3.884,2.872-6.296,3.07c-0.258,0.022-0.53,0.034-0.803,0.034c-5.332,0-9.67-4.338-9.67-9.67 c0-5.332,4.338-9.67,9.67-9.67c0.274,0,0.548,0.012,0.814,0.035c2.403,0.197,4.637,1.287,6.286,3.069 c1.658,1.792,2.571,4.124,2.571,6.567C254.581,157.421,253.668,159.753,252.01,161.544z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2525AD"
    },
    d: "M392.188,304.376l-0.002,0.003c-0.041,0.084-0.079,0.172-0.115,0.263 c-0.686,1.781,0.205,3.789,1.987,4.474c1.781,0.686,3.789-0.206,4.474-1.987c0.035-0.091,0.065-0.181,0.09-0.268 c0.504-1.718-0.409-3.564-2.077-4.206C394.878,302.013,392.963,302.769,392.188,304.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2525AD"
    },
    d: "M399.765,294.294c-0.558-0.215-1.167-0.199-1.714,0.043c-0.547,0.243-0.966,0.684-1.181,1.242 l-0.461,1.197l-0.452-0.033c-0.589-0.043-1.185-0.027-1.77,0.045l-0.449,0.056l-0.521-1.173 c-0.501-1.129-1.827-1.639-2.956-1.138c-0.547,0.243-0.966,0.684-1.181,1.243c-0.215,0.558-0.2,1.167,0.043,1.713l0.521,1.173 l-0.343,0.296c-0.446,0.386-0.857,0.817-1.22,1.283l-0.279,0.357l-1.197-0.461c-0.99-0.381-2.123-0.009-2.693,0.885 c-0.08,0.126-0.148,0.261-0.202,0.4c-0.215,0.558-0.199,1.167,0.043,1.714c0.243,0.547,0.684,0.967,1.242,1.181l1.197,0.461 l-0.033,0.452c-0.043,0.589-0.027,1.185,0.045,1.77l0.056,0.45l-1.173,0.521c-1.128,0.501-1.639,1.827-1.138,2.956 c0.243,0.546,0.684,0.966,1.243,1.181c0.558,0.215,1.167,0.2,1.714-0.043l1.173-0.521l0.296,0.343 c0.385,0.446,0.817,0.857,1.283,1.22l0.357,0.279l-0.461,1.197c-0.444,1.153,0.133,2.451,1.286,2.895 c0.558,0.215,1.167,0.199,1.714-0.043c0.547-0.243,0.966-0.684,1.181-1.242l0.461-1.197l0.452,0.033 c0.589,0.043,1.185,0.027,1.77-0.045l0.449-0.056l0.521,1.173c0.501,1.129,1.827,1.639,2.956,1.138 c0.546-0.243,0.966-0.684,1.181-1.243c0.215-0.558,0.2-1.167-0.043-1.714l-0.521-1.173l0.343-0.296 c0.446-0.386,0.857-0.817,1.22-1.283l0.279-0.357l1.197,0.461c1.153,0.444,2.451-0.133,2.895-1.286 c0.052-0.135,0.091-0.277,0.117-0.422l0.011-0.069c0.059-0.415,0-0.837-0.172-1.223c-0.243-0.547-0.684-0.967-1.242-1.181 l-1.197-0.461l0.033-0.452c0.042-0.589,0.027-1.185-0.045-1.77l-0.056-0.45l1.173-0.521c0.545-0.242,0.964-0.684,1.18-1.243 c0.215-0.559,0.2-1.168-0.042-1.714c-0.243-0.546-0.684-0.966-1.243-1.181c-0.558-0.215-1.167-0.2-1.714,0.043l-1.172,0.521 l-0.296-0.343c-0.386-0.446-0.818-0.857-1.283-1.22l-0.357-0.279l0.461-1.197C401.494,296.037,400.918,294.738,399.765,294.294z  M400.968,303.102c0.699,1.422,0.838,3.04,0.394,4.556c-0.047,0.163-0.104,0.331-0.168,0.497 c-1.251,3.248-4.911,4.874-8.159,3.623c-3.248-1.251-4.874-4.911-3.623-8.159c0.064-0.167,0.136-0.331,0.212-0.487 c0.684-1.418,1.872-2.523,3.344-3.109c1.48-0.59,3.115-0.599,4.603-0.026C399.059,300.568,400.265,301.672,400.968,303.102z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.5ceb84a149b81122c067bb4a074761df.svg";
export { ForwardRef as ReactComponent };